export default __webpack_public_path__ + "static/media/Harness of Untamed Violence.521c630b.jpg";